module.exports = __webpack_public_path__ + "static/img/4.5563491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/4.jpg
// module id = 4mIo
// module chunks = 1